var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "site-footer" }, [
    _c("div", { staticClass: "footer-legal" }, [
      _c("div", { staticClass: "content-max-width flex" }, [
        _c("p", { staticClass: "copyright" }, [_vm._v("© Pool Focus 2021")]),
        _vm._v(" "),
        _c(
          "a",
          { staticClass: "email", attrs: { href: _vm.data.email.link } },
          [_vm._v(_vm._s(_vm.data.email.title))]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "attribution",
            attrs: { href: "https://fromhere.nz/", target: "_blank" }
          },
          [_vm._v("Website From Here")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50e1e017", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e1e017","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Footer.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-50e1e017","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Footer.vue
// module chunks = 0